import { defineFcm } from '../shared/factory';

export const FCM_GDPR_SIGN_OPT_IN = defineFcm('gdpr_sign_opt_in').asBoolean().withDefault(false).toConfig({
	owner: 'TBD',
	scope: 'corgi-front-end',
	context: 'petition page',
	description: 'Indicates whether to display the GDPR opt-in checkboxes to guests.',
});
